// src/store/flightOffersSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFlightOffers } from '../../services/flight/flightServices';

export const fetchFlightOffers = createAsyncThunk(
    'flightOffers/fetchFlightOffers',
    async () => {
        const data = await getFlightOffers();
        return data;
    }
);


const flightOffersSlice = createSlice({
    name: 'flightOffers',
    initialState: {
        offers: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFlightOffers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFlightOffers.fulfilled, (state, action) => {
                state.offers = action.payload;
                state.loading = false;
            })
            .addCase(fetchFlightOffers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default flightOffersSlice.reducer;
